import { Pipe, PipeTransform, inject } from '@angular/core';
import { SSR_IS_MOBILE } from 'projects/ui-kit/src/lib/services/device-detector.service';

@Pipe({
  name: 'groupByColumn'
})
export class GroupByColumnPipe implements PipeTransform {
  private readonly ssrIsMobile = inject(SSR_IS_MOBILE);

  transform(array: any[], columnsCount = 0, containerSelector?: string): any[] {
    columnsCount = columnsCount || this.getColumnsCount(containerSelector);
    const columnItemCount = parseInt(`${array.length/columnsCount}`) || 1;
    const lastRowElms = array.slice((columnsCount * columnItemCount) , array.length);
    const result = [];
    for(let column = 0; column < columnsCount; column++) {
      const slice = array.slice(column * columnItemCount, (column * columnItemCount) + columnItemCount);
      if(slice) {
        result.push(slice);
      }
      if(lastRowElms.length > column){
        result[column].push(lastRowElms[column]);
      }
    }
    return result;
  }

  getColumnsCount(containerSelector) {
    const width = typeof window === 'undefined'
      ? (this.ssrIsMobile ? 600 : 1400)
      : containerSelector
        ? document.querySelector(containerSelector)?.offsetWidth || window.innerWidth
        : window.innerWidth;
    if(width < 768) {
      return 2;
    } else if(width < 992) {
      return 3;
    } else if(width < 1400) {
      return 4;
    } else {
      return 5;
    }
  }

}
